import University from '../../Images/uniedu.netlify.app_(Desktop - Large).png'
import BookHome from '../../Images/bookhomes.netlify.app_(Desktop - Large).png'
import Ounje from '../../Images/ounjebazaar.netlify.app_(Desktop - Large).png'
import TheVenue from '../../Images/venue2.netlify.app_(Desktop - Large).png'
import Zogin from '../../Images/zogin.netlify.app_(Desktop - Large).png'
import Vacation from '../../Images/vacationroom.netlify.app_(Desktop - Large).png'
import Revent from '../../Images/reventtest.netlify.app_(Desktop - Large).png'
import Salvation from '../../Images/salvationhope.netlify.app_index.html(Desktop - MDPI).png'
import Livoca from '../../Images/livoca.org_enroll Medium.png'
import Spendwise from '../../Images/business.spendwise.ng_ Large.png'
import Bubble from '../../Images/bubblecolony.com_ Medium.png'
import Paytton from '../../Images/paytton.com_ Medium.png'

const Projects = [
  {
    name: 'Livoca Website',
    description:
      'An innovative edutech website offering comprehensive user registration and management. Built with a robust full-stack architecture, it ensures a seamless and engaging learning experience. Users can easily sign up, track progress, and access a variety of educational resources. Perfect for students, educators, and lifelong learners seeking a dynamic online learning platform.',
    image: Livoca,
    code: null,
    live: 'https://bookhomes.netlify.app/',
    languages: [
      {
        name: 'React',
        icon: 'uil:react',
      },
      {
        name: 'TypeScript',
        icon: 'teenyicons:typescript-solid',
      },
      {
        name: 'Scss',
        icon: 'fa6-brands:sass',
      },
      {
        name: 'Context API',
        icon: 'simple-icons:redux',
      },
      {
        name: 'Node JS',
        icon: 'la:node',
      },
      {
        name: 'Express JS',
        icon: 'skill-icons:expressjs-light',
      },
      {
        name: 'MongoDB',
        icon: 'simple-icons:mongodb',
      },
    ],
    stack: 'Full-stack',
  },
  {
    name: 'Spendwise.ng',
    description:
      'A financial service that gives users the power to effortlessly manage their expenses, hold and make payments in various currencies, generate virtual and physical cards, and pay bills with ease. This service has the ability to streamline financial management and make it more convenient for users to handle their money. ',
    image: Spendwise,
    code: null,
    live: 'https://business.spendwise.ng/',
    languages: [
      {
        name: 'React',
        icon: 'uil:react',
      },
      {
        name: 'TypeScript',
        icon: 'teenyicons:typescript-solid',
      },
      {
        name: 'Scss',
        icon: 'fa6-brands:sass',
      },
      {
        name: 'Context API',
        icon: 'simple-icons:redux',
      },
      {
        name: 'Node JS',
        icon: 'la:node',
      },
      {
        name: 'AWS Lambda',
        icon: 'simple-icons:awslambda',
      },
      {
        name: 'AWS S3',
        icon: 'simple-icons:amazons3',
      },
    ],
    stack: 'Front-end',
  },
  {
    name: 'Bubble Colony',
    description: `A vibrant e-commerce store for kids, featuring an engaging front-end design. This platform allows users to purchase tickets for popular children's events in their area. Built with a user-friendly interface, it ensures a seamless and enjoyable shopping experience for parents and kids alike. The store integrates event search, ticket buying, and secure checkout functionalities to meet all user needs. `,
    image: Bubble,
    code: null,
    live: 'https://bubblecolony.com/',
    languages: [
      {
        name: 'React',
        icon: 'uil:react',
      },
      {
        name: 'Scss',
        icon: 'fa6-brands:sass',
      },
      {
        name: 'Context API',
        icon: 'simple-icons:redux',
      },
      {
        name: 'Git lab',
        icon: 'mdi:gitlab',
      },
    ],
    stack: 'Front-end',
  },
  {
    name: 'Paytton',
    description: `Paytton enhances collaboration and work efficiency for procurement and finance professionals. Streamline your source-to-pay process and revolutionize the way your teams work together`,
    image: Paytton,
    code: null,
    live: 'https://paytton.com/',
    languages: [
      {
        name: 'React',
        icon: 'uil:react',
      },
      {
        name: 'TypeScript',
        icon: 'teenyicons:typescript-solid',
      },
      {
        name: 'Scss',
        icon: 'fa6-brands:sass',
      },
      {
        name: 'Context API',
        icon: 'simple-icons:redux',
      },
      {
        name: 'Node JS',
        icon: 'la:node',
      },
      {
        name: 'Express JS',
        icon: 'skill-icons:expressjs-light',
      },
      {
        name: 'MongoDB',
        icon: 'simple-icons:mongodb',
      },
    ],
    stack: 'Full-stack',
  },
  {
    name: 'Book Home',
    description:
      'Book Home is a modern e-commerce platform that allows customers to browse and purchase books online. Built using React as the frontend framework and Commerce.js as the e-commerce platform, the website offers a user-friendly interface and a seamless shopping experience.',
    image: BookHome,
    code: 'https://github.com/Favourene/bookhome',
    live: 'https://bookhomes.netlify.app/',
    languages: [
      {
        name: 'React',
        icon: 'uil:react',
      },
      {
        name: 'Scss',
        icon: 'fa6-brands:sass',
      },
      {
        name: 'Context API',
        icon: 'simple-icons:redux',
      },
      {
        name: 'Stripe API',
        icon: 'mage:stripe',
      },
    ],
    stack: 'Full-stack',
  },
  {
    name: 'Ounje Bazaar',
    description:
      'Ounjebazaar is an online international grocery store based out of New Brunswick, Canada. It makes it easy to get fresh, hard-to-find international groceries delivered right to your door.Ounjebazaar has leveraged the features of great SEO techniques to make their site blazing fast and easy to navigate. ',
    image: Ounje,
    code: '',
    live: 'https://ounjebazaar.netlify.app/',
    languages: [
      {
        name: 'React',
        icon: 'uil:react',
      },
      {
        name: 'SCSS',
        icon: 'fa6-brands:sass',
      },
      {
        name: 'Styled components',
        icon: 'simple-icons:styledcomponents',
      },
      {
        name: 'Material Ui',
        icon: 'mdi:material-ui',
      },
      {
        name: 'Context API',
        icon: 'simple-icons:redux',
      },
      {
        name: 'Stripe API',
        icon: 'mage:stripe',
      },
    ],
    stack: 'Full-stack',
  },
  {
    name: 'The Venue',
    description:
      'The Venue is a restaurant website designed for a fictional restaurant called "The Venue". It was built using HTML, CSS, and JavaScript. The website features a clean, modern design with a responsive layout that adapts to different screen sizes.The website also includes a chat feature that allows users to communicate with a customer service representative in real-time',
    image: TheVenue,
    code: '',
    live: 'https://venue2.netlify.app/',
    languages: [
      {
        name: 'HTML',
        icon: 'akar-icons:html-fill',
      },
      {
        name: 'CSS',
        icon: 'akar-icons:css-fill',
      },
      {
        name: 'Javascript',
        icon: 'devicon-plain:javascript',
      },
      {
        name: 'Twak.io',
        icon: 'ri:customer-service-2-line',
      },
    ],
    stack: 'Front-end',
  },
  {
    name: 'Zogin',
    description:
      'The website is a single-page application that provides information about yoga and allows users to view different yoga poses. The website makes use of HTML, CSS, and JavaScript to create a visually appealing and interactive experience for users. ',
    image: Zogin,
    code: 'https://github.com/Favourene/zogin',
    live: 'https://zogin.netlify.app/',
    languages: [
      {
        name: 'HTML',
        icon: 'akar-icons:html-fill',
      },
      {
        name: 'CSS',
        icon: 'akar-icons:css-fill',
      },
      {
        name: 'Javascript',
        icon: 'devicon-plain:javascript',
      },
    ],
    stack: 'Front-end',
  },
  {
    name: 'Revent Tech',
    description:
      'The website, built using React and SCSS, is a sleek and professional representation of a tech innovation company. The design is pixel perfect, ensuring that all elements are sharp and crisp on any device.The layout is clean and easy to navigate, with a focus on showcasing the companys innovative products and services.',
    image: Revent,
    code: 'https://github.com/Favourene/React-Test',
    live: 'https://reventtest.netlify.app/',
    languages: [
      {
        name: 'React',
        icon: 'uil:react',
      },
      {
        name: 'Scss',
        icon: 'fa6-brands:sass',
      },
      {
        name: 'Context API',
        icon: 'simple-icons:redux',
      },
    ],
    stack: 'Front-end',
  },
  {
    name: 'Vacation Room',
    description:
      'Vacation Room is an online booking platform that helps travelers find unique accommodation options in the world’s most beautiful destinations. With Vacation Room, users can browse through a wide selection of room types, amenities, and additional services to create the perfect vacation. Vacation Room offers unique lodging experiences at unbeatable prices.',
    image: Vacation,
    code: 'https://github.com/Favourene/Vacation-Rental',
    live: 'https://vacationroom.netlify.app/',
    languages: [
      {
        name: 'HTML',
        icon: 'akar-icons:html-fill',
      },
      {
        name: 'CSS',
        icon: 'akar-icons:css-fill',
      },
      {
        name: 'Javascript',
        icon: 'devicon-plain:javascript',
      },
    ],
    stack: 'Front-end',
  },
  {
    name: 'University Website',
    description:
      'The React and SCSS website I built is for a fictional university. It features a clean and modern design with a focus on usability. The homepage includes a carousel of featured events and a section for recent news updates.',
    image: University,
    code: 'https://github.com/Favourene/education',
    live: 'https://uniedu.netlify.app/',
    languages: [
      {
        name: 'React',
        icon: 'uil:react',
      },
      {
        name: 'Scss',
        icon: 'fa6-brands:sass',
      },
      {
        name: 'Context API',
        icon: 'simple-icons:redux',
      },
    ],
    stack: 'Front-end',
  },
  {
    name: 'Salvation Hope',
    description:
      'Salvation Hope is a simple and cleanly designed website built using HTML and CSS. The website features a homepage that displays a full-screen background image with a navigation menu fixed to the top of the page. The navigation menu includes links to various pages such as "Home", "About Us", "Contact Us", and "Donate".',
    image: Salvation,
    code: 'https://github.com/Favourene/Salvation',
    live: 'https://salvationhope.netlify.app/',
    languages: [
      {
        name: 'HTML',
        icon: 'akar-icons:html-fill',
      },
      {
        name: 'CSS',
        icon: 'akar-icons:css-fill',
      },
      {
        name: 'Javascript',
        icon: 'devicon-plain:javascript',
      },
    ],
    stack: 'Front-end',
  },
]

export default Projects
